import PutOrganisationRequestModelBase from '../_generated/modelBases/put-organisation-request-model-base';

export default class PutOrganisationRequestModel extends PutOrganisationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
